import React, { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import Pink from "./Pink";
import hemPNG from "../images/hem.png";
import smokePNG from "../images/smoke.png";
import SinglePie from "./Biases/Graphs/SinglePie";

// import progCap from "../images/prog_sep.png";
// import reportCap from "../images/report_sep.png";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { useHistory } from "react-router-dom";

//import Scrollbar from "smooth-scrollbar";

gsap.registerPlugin(ScrollTrigger);

export default function Home() {
  let history = useHistory();

  useLayoutEffect(() => {

    var wrap = function (toWrap) {
      let wrapper = document.createElement("div");
      wrapper.className = "span-wrapper";
      toWrap.parentNode.appendChild(wrapper);
      return wrapper.appendChild(toWrap);
    };

    let quote_spans = document.querySelectorAll(".quote-section span");
    let hero_spans = document.querySelectorAll(".hero-left span");
    let feature_spans = document.querySelectorAll(".feature-header span");
    let cta_spans = document.querySelectorAll(".cta-header span");

    Array.prototype.forEach.call(quote_spans, function (span) {
      if (span.parentElement.className !== "span-wrapper") {
        wrap(span);
      }
    });

    Array.prototype.forEach.call(hero_spans, function (span) {
      if (span.parentElement.className !== "span-wrapper") {
        wrap(span);
      }
    });

    Array.prototype.forEach.call(feature_spans, function (span) {
      if (span.parentElement.className !== "span-wrapper") {
        wrap(span);
      }
    });

    Array.prototype.forEach.call(cta_spans, function (span) {
      if (span.parentElement.className !== "span-wrapper") {
        wrap(span);
      }
    });

    return () => { };
  }, []);

  // //layout effect for smooth scrolling effect on desktop
  // useLayoutEffect(() => {
  //   console.log(Scrollbar.getAll());

  //   if (dimensions.width >= 800) {
  //     //smooth scroll
  //     document.body.style.maxHeight = "100vh";

  //     let bodyScrollBar = Scrollbar.init(document.body, {
  //       damping: 0.1,
  //       renderByPixels: false,
  //       thumbMinSize: 100,
  //     });
  //     Scrollbar.detachStyle();
  //     bodyScrollBar.setPosition(0, 0);
  //     bodyScrollBar.track.xAxis.element.remove();

  //     ScrollTrigger.scrollerProxy("body", {
  //       scrollTop(value) {
  //         if (arguments.length) {
  //           bodyScrollBar.scrollTop = value;
  //         }
  //         return bodyScrollBar.scrollTop;
  //       },
  //     });
  //     bodyScrollBar.addListener(ScrollTrigger.update);
  //     document.body.style.overflow = "hidden";

  //     let moreFade;
  //     function scrollListener() {
  //       moreFade = gsap.to(".hero-more", { opacity: 0 });
  //     }

  //     bodyScrollBar.addListener(scrollListener);
  //     console.log(Scrollbar.getAll());

  //     return () => {
  //       document.body.removeAttribute("style");
  //       document.body.removeAttribute("data-scrollbar");
  //       document.body.removeAttribute("tabindex");
  //       bodyScrollBar.removeListener(scrollListener);
  //       Scrollbar.destroy(bodyScrollBar);

  //       let Allbars = Scrollbar.getAll();
  //       for (let i = 0; i < Allbars.length; i++) {
  //         Allbars[i].destroy();
  //       }
  //       if (moreFade !== undefined) {
  //         moreFade.kill();
  //       }
  //       document.body.style.maxHeight = "auto";
  //       document.body.style.overflow = "visible";
  //     };
  //   }
  // }, [dimensions.width]);

  //layout effect for mobile scroll event listener
  useLayoutEffect(() => {
    let moreFade;
    function scrollListener() {
      moreFade = gsap.timeline();
      moreFade.to(".hero-more", { autoAlpha: 0 }).to(".hero-more", { display: "none" }, "<");
    }
    window.addEventListener("scroll", scrollListener);

    return () => {
      if (moreFade !== undefined) {
        moreFade.kill();
      }
      window.removeEventListener("scroll", scrollListener);
    };
  }, []);

  //home hero anim, useeffect so animation runs only after DOM is painted

  useLayoutEffect(() => {
    if (history.action === "POP") {
      document.querySelector(".nav-items").style.opacity = "0";
    }
    //ScrollTrigger.refresh();
  });

  useLayoutEffect(() => {
    // const staggerAmount = 1;
    // const staggerEach = 0.05;


    let tl_hero = gsap.timeline();

    tl_hero
      .add(
        gsap
          .fromTo(
            ".hero-section  span",
            { y: "100%" },
            {
              y: "0",
              stagger: 0.2,
            }
          )
          .duration(1.2)
          .delay(history.action === "POP" ? 0.5 : 0.3)
        //.delay(0.3)
      )
      .fromTo(".hero-right", { autoAlpha: 0 }, { autoAlpha: 1, duration: 1.7 }, ">")
      .fromTo(".purple-light.home", { autoAlpha: 0 }, { autoAlpha: 0.7, duration: 1.7 }, "<")
      .fromTo(".red-light.home", { autoAlpha: 0 }, { autoAlpha: 0.7, duration: 1.7 }, "<")
      .fromTo(
        ".cta-container",
        { y: -2, autoAlpha: 0 },
        { duration: 1.8, y: 0, autoAlpha: 1 },
        "<+=0.1"
      )
      .fromTo(
        ".section-subheader",
        { y: -2, autoAlpha: 0 },
        { duration: 1.8, y: 0, autoAlpha: 1 },
        "<+=0.2"
      )

      .fromTo(".hero-right", { y: 10 }, { y: 0, duration: 1.5 }, ">-=2")
      .fromTo(
        ".hero-more",
        { autoAlpha: 0, yPercent: -320 },
        { autoAlpha: 1, yPercent: -220, duration: 0.8, repeat: -1, repeatDelay: 0.5 },
        "<"
      );

    if (history.action === "POP") {
      tl_hero.fromTo(".nav-items", { autoAlpha: 0 }, { autoAlpha: 1, duration: 1.5 }, "<+=0.3");
    }

    return () => {
      tl_hero.kill();
    };
  });

  //layout effect to read attributes
  useLayoutEffect(() => {


    var isSafari =
      navigator.vendor &&
      navigator.vendor.indexOf("Apple") > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf("CriOS") == -1 &&
      navigator.userAgent.indexOf("FxiOS") == -1;

    // const dimensions = {
    //   height: window.innerHeight,
    //   width: window.innerWidth,
    // };
    let borderWidthFirst = document
      .querySelector("#first-quote-subtext")
      .getBoundingClientRect().width;
    let borderWidthSecond = document
      .querySelector("#second-quote-subtext")
      .getBoundingClientRect().width;
    // document
    //   .querySelector(".border-mask.first")
    //   .setAttribute("d", `M 0 5 l ${borderWidthFirst} 0.00001`);
    // document
    //   .querySelector(".border-mask.second")
    //   .setAttribute("d", `M 0 5 l ${borderWidthSecond} 0.00001`);
    document
      .querySelector(".border-path.first")
      .setAttribute("d", `M 0 5 l ${borderWidthFirst} 0.00001`);
    document
      .querySelector(".border-path.second")
      .setAttribute("d", `M 0 5 l ${borderWidthSecond} 0.00001`);
    document.querySelectorAll(".border-svg")[0].setAttribute("width", `${borderWidthFirst}`);
    document.querySelectorAll(".border-svg")[1].setAttribute("width", `${borderWidthSecond}`);

    // let boxes = document.getElementsByClassName("quote-bar");
    // let shadow = "";
    // for (var i = 0; i < 75; i++) {
    //   shadow += (shadow ? "," : "") + i * 1 + "px " + i * 1 + "px 5px rgba(0,0,0,0.006)";
    // }
    // Array.prototype.forEach.call(boxes, function (box) {
    //   box.style.boxShadow = shadow;
    // });

    //GSAP
    const staggerAmount = 1;
    const staggerEach = 0.05;

    //main content animations

    let tl_firstQuote = gsap.timeline({
      //paused: true,
      scrollTrigger: {
        id: "firstQuote",

        trigger: ".quote-container.first",
        start: "top-=100 center",
      },
      //remove
      //repeat: -1,
    });

    //first quote
    let firstQuoteReveal = gsap
      .fromTo(
        ".quote-container.first > .quote-text  span",
        { yPercent: 100 },
        {
          yPercent: 0,
          stagger: staggerEach,
        },
        0
      )
      .duration(staggerAmount);
    tl_firstQuote
      .add(firstQuoteReveal, 0)
      .fromTo(
        ".border-svg.first",
        {
          clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)",
        },
        {
          clipPath: "polygon(0% 0, 100% 0, 100% 100%, 0% 100%)",
          duration: staggerAmount,
          ease: "power1.out",
        },
        "<"
      )
      .fromTo(
        ".quote-container.first > .quote-author-container > .quote-author",
        { x: -8, autoAlpha: 0 },
        { x: 0, autoAlpha: 1, duration: 0.3 },
        ">"
      )
      .fromTo(
        ".quote-container.first > .quote-author-container > .quote-author-subtext",
        { x: -5, autoAlpha: 0 },
        { x: 0, autoAlpha: 1, duration: 0.3 },
        ">-=0.1"
      )
      .fromTo(
        ".hem",
        {
          opacity: 0,
        },
        {
          opacity: 0.2,
          duration: 2,
        },
        "0"
      );

    let tl_exclam = gsap.timeline({
      scrollTrigger: {
        trigger: ".quote-danger-container",
        start: "center center",
        end: "bottom center",
        scrub: 2,
      },
    });

    tl_exclam
      .fromTo(
        ".smoke",
        {
          xPercent: -50,
          yPercent: -50,
        },
        {
          xPercent: -50,
          yPercent: -70,
        },
        "<"
      )

    if (!isSafari) {

      tl_exclam.fromTo(
        ".exclam-stroke",
        {
          strokeDashoffset: 380,
        },
        {
          strokeDashoffset: 0,
        },
        "<"
      )
        .fromTo(
          ".exclam-circle",
          {
            strokeDashoffset: 120,
          },
          {
            strokeDashoffset: 0,
          },
          "<"
        );
    }

    if (isSafari) {
      document.querySelectorAll(".exclam-stroke").forEach((path) => {
        path.style.strokeDashoffset = "0"
      });
      document.querySelectorAll(".exclam-circle").forEach((path) => {
        path.style.strokeDashoffset = "0"
      });
    }

    let tl_blinking = gsap.timeline({
      scrollTrigger: {
        trigger: ".quote-danger-container",
        start: "bottom+=70 center",
      },
    });

    tl_blinking
      .to(".exclam", { opacity: 0.2, duration: 0.1 }, "<")
      .to(".exclam", { opacity: 1, duration: 0.1 }, ">+=0.1")
      .to(".exclam", { opacity: 0.2, duration: 0.1 }, ">")
      .to(".exclam", { opacity: 1, duration: 0.1 }, ">");

    let tl_secondQuote = gsap.timeline({
      //paused: true,
      scrollTrigger: {
        id: "secondQuote",

        trigger: ".quote-container.second",
        start: "top center",
      },
      //repeat: -1,
    });

    //second quote
    let secondQuoteReveal = gsap
      .fromTo(
        ".quote-container.second > .quote-text  span",
        { yPercent: 100 },
        {
          yPercent: 0,
          stagger: staggerEach,
        },
        0
      )
      .duration(staggerAmount);
    tl_secondQuote
      .add(secondQuoteReveal, 0)
      .fromTo(
        ".border-svg.second",
        {
          clipPath: "polygon(100% 0, 100% 0, 100% 100%, 100% 100%)",
        },
        {
          clipPath: "polygon(0% 0, 100% 0, 100% 100%, 0% 100%)",
          duration: staggerAmount,
          ease: "power1.out",
        },
        "<"
      )
      .fromTo(
        ".quote-container.second > .quote-author-container > .quote-author",
        { x: 8, autoAlpha: 0 },
        { x: 0, autoAlpha: 1, duration: 0.3 },
        ">"
      )
      .fromTo(
        ".quote-container.second > .quote-author-container > .quote-author-subtext",
        { x: 5, autoAlpha: 0 },
        { x: 0, autoAlpha: 1, duration: 0.3 },
        ">-=0.1"
      );

    let tl_secondQuoteFigure = gsap.timeline({
      scrollTrigger: {
        trigger: ".quote-container.second",
        start: "top center",
      },
      //repeat: -1,
      //remove
    });

    tl_secondQuoteFigure
      .fromTo(
        ".quote-bar-container .grid-bg",
        { clipPath: "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)", opacity: 0 },
        { clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", opacity: 1, duration: 1 },
        ">"
      )
      .fromTo(
        ".quote-bar-container .grid-bg-vignette",
        { opacity: 0 },
        { opacity: 1, duration: 1 },
        "<"
      )
      .fromTo(".quote-bar", { autoAlpha: 0 }, { autoAlpha: 1, duration: 1.2 }, "<")
      .fromTo(".bar-5", { scaleY: 1.5 }, { scaleY: 2.9, duration: 0.75, ease: "power1.inOut" }, "<")
      .fromTo(".bar-4", { scaleY: 1 }, { scaleY: 1.5, duration: 0.75, ease: "power1.inOut" }, "<")
      .fromTo(".bar-3", { scaleY: 1.3 }, { scaleY: 2.2, duration: 0.75, ease: "power1.inOut" }, "<")
      .fromTo(".bar-2", { scaleY: 1.2 }, { scaleY: 0.8, duration: 0.75, ease: "power1.inOut" }, "<")
      .fromTo(".bar-1", { scaleY: 0.3 }, { scaleY: 0.4, duration: 0.75, ease: "power1.inOut" }, "<")

      .to(".bar-5", { scaleY: 1, duration: 0.95, ease: "power1.inOut" }, ">+=0.1")
      .to(".bar-4", { scaleY: 1, duration: 0.95, ease: "power1.inOut" }, "<")
      .to(".bar-3", { scaleY: 1, duration: 0.95, ease: "power1.inOut" }, "<")
      .to(".bar-2", { scaleY: 1, duration: 0.95, ease: "power1.inOut" }, "<")
      .to(".bar-1", { scaleY: 1, duration: 0.95, ease: "power1.inOut" }, "<")

      .fromTo(
        ".bar-1",
        {
          background: "linear-gradient(180deg, #0d102b 0%, rgba(13, 16, 43, 0) 100%)",
        },
        {
          background: "linear-gradient(180deg, #99056f 0%, rgba(13, 16, 43, 0) 100%)",
          duration: 0.75,
          ease: "power1.inOut",
        },
        "<"
      );

    // .fromTo(
    //   ".bar-1",
    //   {
    //     scaleY: 0,
    //   },
    //   {
    //     scaleY: 1,
    //     //stagger: { each: 0.2, from: "end" },
    //     duration: 1.8,
    //     ease: "power4.In",
    //   },

    //   "<"
    // );
    // let bars = document.querySelectorAll(".quote-bar");
    // let barHeights = [];

    // bars.forEach((element) => {
    //   let elHeight = element.getBoundingClientRect().height;
    //   barHeights.push(elHeight);
    // });

    // bars.forEach((element) => {
    //   let elHeight = element.getBoundingClientRect().height;
    //   let maxHeight = Math.max(...barHeights);
    //   let minHeight = Math.min(...barHeights);
    //   let durationNorm = (elHeight - minHeight) / (maxHeight - minHeight);
    //   tl_secondQuote.fromTo(
    //     element,
    //     { scaleY: 0, opacity: 0 },
    //     {
    //       scaleY: 1,
    //       opacity: 1,

    //       duration: durationNorm,
    //       ease: "linear",
    //     },
    //     1.8
    //   );
    // });

    let tl_feature = gsap.timeline({
      paused: true,
      scrollTrigger: {
        id: "feature",
        trigger: ".feature-section",
        start: "top center",
      },
    });
    // let featureHeaderReveal = gsap
    //   .fromTo(
    //     ".feature-header  span",
    //     { yPercent: 100 },
    //     {
    //       yPercent: 0,
    //       stagger: staggerEach,
    //     },
    //     0
    //   )
    //   .duration(staggerAmount - 0.4);

    tl_feature
      // .fromTo(".feature-items-container", { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.5 })
      // .add(featureHeaderReveal, "<")
      .fromTo(
        ".feature-item-header.first-item",
        { y: 0, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, duration: 0.3 },
        ">"
      )
      .fromTo(
        ".feature-item-text.first-item",
        { y: 5, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, duration: 0.3 },
        ">-=0.1"
      )
      .fromTo(
        ".feature-item-icon.first-item",
        { y: -5, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, duration: 0.3 },
        ">-=0.1"
      );
    tl_feature
      .fromTo(
        ".feature-item-header.second-item",
        { y: 0, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, duration: 0.3 },
        ">-=0.1"
      )
      .fromTo(
        ".feature-item-text.second-item",
        { y: 5, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, duration: 0.3 },
        ">-0.1"
      )
      .fromTo(
        ".feature-item-icon.second-item",
        { y: -5, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, duration: 0.3 },
        ">-=0.1"
      );

    let tl_featureFigureFirst = gsap.timeline({
      scrollTrigger: {
        trigger: ".feature-extra.first",
        start: "top center",
      },
    });

    tl_featureFigureFirst
      .fromTo(".home-wtm", { opacity: 0, x: -20 }, { opacity: 1, x: 0, duration: 1 })
      .fromTo(".feature-extra .bias-graph", { opacity: 0 }, { opacity: 1, duration: 1 }, "<")
      .fromTo(
        ".feature-extra .cut-crcl",
        { backgroundImage: "conic-gradient(rgba(255, 255, 255, 0) 0%, rgb(27, 29, 45) 0%)" },
        {
          backgroundImage: "conic-gradient(rgba(255, 255, 255, 0) 42.5%, rgb(27, 29, 45) 42.5%)",
          duration: 1.5,
        },
        "<"
      );

    let tl_featureFigureSecond = gsap.timeline({
      scrollTrigger: {
        trigger: ".feature-extra.second",
        start: "top center",
      },
    });

    tl_featureFigureSecond
      .fromTo(".feature-extra .grid-bg", { opacity: 0 }, { opacity: 1, duration: 1 })
      .fromTo(".feature-extra .grid-bg-vignette", { opacity: 0 }, { opacity: 1, duration: 1 }, "<")
      .fromTo(
        ".feature-graph-svg path",
        { strokeDashoffset: 720 },
        { strokeDashoffset: 0, duration: 1.5 },
        "<"
      )
      .fromTo(".feature-extra .path-marker", { opacity: 0 }, { opacity: 1, duration: 1.5 }, "<");

    //.fromTo("", {}, {});
    let tl_cta = gsap.timeline({
      paused: true,
      scrollTrigger: {
        id: "cta-section",
        //trigger: ".feature-items-container",
        //start: () => `bottom+=${32 + 100 + Math.min(dimensions.width, 900) / 2.015} center`,
        trigger: ".cta-header",
        // start: () => `bottom-=${dimensions.height <= 600 ? 200 : 50} bottom`,
        start: "top+=150 bottom",
      },
    });
    let ctaHeaderReveal = gsap
      .fromTo(
        ".cta-header span",
        { yPercent: 100 },
        {
          yPercent: 0,
          stagger: staggerEach,
        },
        0
      )
      .duration(staggerAmount);

    tl_cta
      .add(ctaHeaderReveal, "<")
      .fromTo(
        ".cta-section a.cta",
        { y: 10, autoAlpha: 0 },
        { duration: 0.5, y: 0, autoAlpha: 1 },
        ">-=0.3"
      );

    return () => {
      // let Alltrigger = ScrollTrigger.getAll();
      // for (let i = 0; i < Alltrigger.length; i++) {
      //   Alltrigger[i].kill(true);
      // }

      //tl_hero.kill();
      //tl_hero_more.kill();
      tl_firstQuote.kill();
      tl_exclam.kill();
      tl_blinking.kill();
      tl_secondQuote.kill();
      tl_secondQuoteFigure.kill();
      tl_feature.kill();
      tl_featureFigureFirst.kill();
      tl_featureFigureSecond.kill();
      tl_cta.kill();
    };
  });

  return (
    <>
      <div id="home-both-align" className="section-container home">
        <div className="purple-light home"> </div>
        <div className="red-light home"> </div>
        <section className="hero-section">
          <div className="hero-left">
            <h1 className="section-header home-section-header">
              <span>Reveal your </span>
              <span>trading biases</span>
            </h1>
            <h2 className="section-subheader">Import your trades. Done</h2>
            <div className="cta-container">
              <Link className="cta" to="/dashboard">
                Get started
              </Link>
            </div>
            {/* <div className="hero-more">
              Find out more <div> down </div>
            </div> */}
          </div>

          <div className="hero-right">
            <Pink />
          </div>

          <div className="hero-more material-icons"> expand_more </div>
        </section>
        <section className="quote-section">
          <div className="quote-container first">
            <h3 className="quote-text">
              {/* <a
                href="https://www.youtube.com/watch?v=WaDU1J91hY8&t=1029s"
                target="_blank"
                rel="noreferrer"
              > */}
              <span>The </span>
              <span>greatest </span>
              <span>investors </span>
              <span>recognize </span>
              <span>the </span>
              <span>dangers </span>
              <span>of </span>
              <span>decision </span>
              <span>biases.</span>
            </h3>
            <div className="quote-author-container">
              <div className="quote-author first">From Benjamin Graham to Charles T. Munger</div>
              <div id="first-quote-subtext" className="quote-author-subtext">
                As in "The Intelligent Investor" or "Poor Charlie's Almanack"
              </div>
              <div className="quote-author-subtext-border">
                <svg className="border-svg first" height="20px">
                  {/* <defs>
                    <mask id="id-border-mask-first">
                      <path className="border-mask first" d="M 0 5 l 400 0.00001" />
                    </mask>
                  </defs> */}

                  <path
                    className="border-path first"
                    d="M 0 5 l 400 0.00001"
                  // mask="url(#id-border-mask-first)"
                  />
                </svg>
              </div>
            </div>
            <div className="quote-danger-container">
              <div className="hem-container">
                <img
                  className="hem"
                  src={hemPNG}
                  onLoad={() => {
                    //ScrollTrigger.refresh();
                  }}
                  alt="Illustration of the human brain"
                />
                <img
                  className="smoke"
                  src={smokePNG}
                  onLoad={() => {
                    //ScrollTrigger.refresh();
                  }}
                  alt="Black smoke"
                />
                <div className="exclam-container">
                  <svg
                    className="exclam"
                    width="110"
                    height="265"
                    viewBox="0 0 110 265"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_d_328_134)">
                      <path
                        className="exclam-circle"
                        d="M73.9796 212.671C78.5054 223.387 73.4869 235.743 62.7705 240.269C52.0542 244.795 39.698 239.776 35.1722 229.06C30.6464 218.344 35.6649 205.988 46.3813 201.462C48.6096 200.521 50.9088 199.992 53.1937 199.842C55.3006 199.703 57.3953 199.886 59.4112 200.363"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </g>
                    <g filter="url(#filter1_d_328_134)">
                      <path
                        className="exclam-circle"
                        d="M73.9796 212.671C78.5054 223.387 73.4869 235.743 62.7705 240.269C52.0542 244.795 39.698 239.776 35.1722 229.06C30.6464 218.344 35.6649 205.988 46.3813 201.462C48.6096 200.521 50.9088 199.992 53.1937 199.842C55.3006 199.703 57.3953 199.886 59.4112 200.363"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </g>
                    <path
                      className="exclam-circle"
                      d="M73.9796 212.671C78.5054 223.387 73.4869 235.743 62.7705 240.269C52.0542 244.795 39.698 239.776 35.1722 229.06C30.6464 218.344 35.6649 205.988 46.3813 201.462C48.6096 200.521 50.9088 199.992 53.1937 199.842C55.3006 199.703 57.3953 199.886 59.4112 200.363"
                      stroke="#DB2E57"
                      strokeWidth="5"
                      strokeLinecap="round"
                    />
                    <g filter="url(#filter2_f_328_134)">
                      <path
                        className="exclam-circle"
                        d="M73.9796 212.671C78.5054 223.387 73.4869 235.743 62.7705 240.269C52.0542 244.795 39.698 239.776 35.1722 229.06C30.6464 218.344 35.6649 205.988 46.3813 201.462C48.6096 200.521 50.9088 199.992 53.1937 199.842C55.3006 199.703 57.3953 199.886 59.4112 200.363"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                      />
                    </g>
                    <g filter="url(#filter3_d_328_134)">
                      <path
                        className="exclam-stroke"
                        d="M87.0596 23.381H32.8551C26.8141 23.381 22.1525 28.6962 22.9406 34.6855L41.0268 172.141C41.6815 177.117 45.9228 180.836 50.9414 180.836H61.0365C66.0498 180.836 70.2884 177.124 70.9492 172.155L87.0596 51.0047"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </g>
                    <g filter="url(#filter4_d_328_134)">
                      <path
                        className="exclam-stroke"
                        d="M87.0596 23.381H32.8551C26.8141 23.381 22.1525 28.6962 22.9406 34.6855L41.0268 172.141C41.6815 177.117 45.9228 180.836 50.9414 180.836H61.0365C66.0498 180.836 70.2884 177.124 70.9492 172.155L87.0596 51.0047"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </g>
                    <path
                      className="exclam-stroke"
                      d="M87.0596 23.381H32.8551C26.8141 23.381 22.1525 28.6962 22.9406 34.6855L41.0268 172.141C41.6815 177.117 45.9228 180.836 50.9414 180.836H61.0365C66.0498 180.836 70.2884 177.124 70.9492 172.155L87.0596 51.0047"
                      stroke="#DB2E57"
                      strokeWidth="5"
                      strokeLinecap="round"
                    />
                    <g filter="url(#filter5_f_328_134)">
                      <path
                        className="exclam-stroke"
                        d="M87.0596 23.381H32.8551C26.8141 23.381 22.1525 28.6962 22.9406 34.6855L41.0268 172.141C41.6815 177.117 45.9228 180.836 50.9414 180.836H61.0365C66.0498 180.836 70.2884 177.124 70.9492 172.155L87.0596 51.0047"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_328_134"
                        x="11.0066"
                        y="177.297"
                        width="87.1384"
                        height="87.1378"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="10" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.941667 0 0 0 0 0 0 0 0 0 0.226 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_328_134"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_328_134"
                          result="shape"
                        />
                      </filter>
                      <filter
                        id="filter1_d_328_134"
                        x="11.0066"
                        y="177.297"
                        width="87.1384"
                        height="87.1378"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="10" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.941667 0 0 0 0 0 0 0 0 0 0.226 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_328_134"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_328_134"
                          result="shape"
                        />
                      </filter>
                      <filter
                        id="filter2_f_328_134"
                        x="31.0068"
                        y="197.297"
                        width="47.1379"
                        height="47.1375"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="BackgroundImageFix"
                          result="shape"
                        />
                        <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_328_134" />
                      </filter>
                      <filter
                        id="filter3_d_328_134"
                        x="0.353027"
                        y="0.880981"
                        width="109.207"
                        height="202.455"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="10" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.941667 0 0 0 0 0 0 0 0 0 0.226 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_328_134"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_328_134"
                          result="shape"
                        />
                      </filter>
                      <filter
                        id="filter4_d_328_134"
                        x="0.353027"
                        y="0.880981"
                        width="109.207"
                        height="202.455"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="10" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.941667 0 0 0 0 0 0 0 0 0 0.226 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_328_134"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_328_134"
                          result="shape"
                        />
                      </filter>
                      <filter
                        id="filter5_f_328_134"
                        x="20.3533"
                        y="20.881"
                        width="69.2065"
                        height="162.455"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="BackgroundImageFix"
                          result="shape"
                        />
                        <feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_328_134" />
                      </filter>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="quote-container second text-align-right">
            <h3 className="quote-text second text-align-right">
              <a
                href="https://www.mckinsey.com/business-functions/strategy-and-corporate-finance/our-insights/high-performing-boards-whats-on-their-agenda"
                target="_blank"
                rel="noreferrer"
              >
                <span>Reducing </span>
                <span>decision </span>
                <span>biases </span>
                <span>is </span>
                <span>the </span>
                <span>biggest </span>
                <span>aspiration </span>
                <span>of </span>
                <span>high-impact </span>
                <span>boards.</span>
              </a>
            </h3>
            <div className="quote-author-container text-align-right">
              <div className="quote-author right">According to a report by McKinsey Quarterly</div>
              <div id="second-quote-subtext" className="quote-author-subtext text-align-right">
                Business Magazine for Senior Executives
              </div>
              <div className="quote-author-subtext-border text-align-right">
                <svg className="border-svg second" height="20px">
                  <defs>
                    {/* <mask id="id-border-mask-second">
                      <path className="border-mask second" d="M 0 5 l 400 0.00001" />
                    </mask> */}
                  </defs>
                  <path
                    className="border-path second"
                    d="M 0 5 l 400 0.00001"
                  // mask="url(#id-border-mask-second)"
                  />
                </svg>
              </div>
            </div>

            <div className="quote-bar-container">
              <div className="quote-bar bar-1"></div>
              <div className="quote-bar bar-2 "></div>
              <div className="quote-bar bar-3 "></div>
              <div className="quote-bar bar-4 "></div>
              <div className="quote-bar bar-5 "></div>
              <div className="grid-bg-vignette"></div>
              <div className="grid-bg"></div>
            </div>
          </div>
        </section >
        <section className="feature-section">
          <div className="feature-items">
            <h3 className="feature-header">
              <span>The </span>
              <span>worst </span>
              <span>enemy </span>
              <span>of </span>
              <span>your </span>
              <span>profits </span>
              <span>is...</span>
            </h3>
            <div className="feature-item-wrapper">
              <div className="feature-item">
                <div className="feature-item-icon first-item">
                  <span className="material-icons acc-icons bar-icon">bar_chart</span>
                </div>
                <div className="feature-item-header first-item">Quantify your biases.</div>
                <p className="feature-item-text first-item">
                  We all know that they influence our trades. Problems arise from not knowing how
                  much. Putting a number on them is the first step towards improvement.
                </p>
              </div>
              <div className="feature-extra first">
                <div className="home-wtm">Disposition Effect</div>
                <figure className="bias-graph">
                  <SinglePie effectPerc={"42.5%"} />
                </figure>
              </div>
            </div>
            <div className="feature-item-wrapper">
              <div className="feature-item">
                <div className="feature-item-icon second-item">
                  <span className="material-icons acc-icons ">timeline</span>
                </div>
                <div className="feature-item-header second-item">Track your progress.</div>
                <p className="feature-item-text second-item">
                  Take the right actions by observing the evolution of your biases through time. Did
                  you become more or less susceptible to them in the last months?
                </p>
              </div>
              <div className="feature-extra second">
                <div className="feature-graph">
                  <div className="grid-bg"></div>
                  <div className="grid-bg-vignette"></div>
                  <svg
                    className="feature-graph-svg"
                    width="524"
                    height="192"
                    viewBox="0 0 524 192"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 146.821L130.642 7L259.285 147L387.927 68.6414L516.57 184"
                      stroke="#370028"
                      strokeWidth="3"
                      strokeLinecap="round"
                    />
                    <g className="path-marker" filter="url(#filter0_d_338_25)">
                      <ellipse cx="131.071" cy="7.5" rx="3.00166" ry="3.5" fill="#B60081" />
                    </g>
                    <g className="path-marker" filter="url(#filter1_d_338_25)">
                      <path
                        d="M262.715 146C262.715 147.933 261.371 149.5 259.714 149.5C258.056 149.5 256.712 147.933 256.712 146C256.712 144.067 258.056 142.5 259.714 142.5C261.371 142.5 262.715 144.067 262.715 146Z"
                        fill="#B60081"
                      />
                    </g>
                    <g className="path-marker" filter="url(#filter2_d_338_25)">
                      <ellipse cx="387.498" cy="70.5" rx="3.00166" ry="3.5" fill="#B60081" />
                    </g>
                    <g className="path-marker" filter="url(#filter3_d_338_25)">
                      <ellipse cx="516.998" cy="184.5" rx="3.00166" ry="3.5" fill="#B60081" />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_338_25"
                        x="124.07"
                        y="0"
                        width="14.0034"
                        height="15"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.713726 0 0 0 0 0 0 0 0 0 0.505882 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_338_25"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_338_25"
                          result="shape"
                        />
                      </filter>
                      <filter
                        id="filter1_d_338_25"
                        x="252.712"
                        y="138.5"
                        width="14.0034"
                        height="15"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.713726 0 0 0 0 0 0 0 0 0 0.505882 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_338_25"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_338_25"
                          result="shape"
                        />
                      </filter>
                      <filter
                        id="filter2_d_338_25"
                        x="380.497"
                        y="63"
                        width="14.0034"
                        height="15"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.713726 0 0 0 0 0 0 0 0 0 0.505882 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_338_25"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_338_25"
                          result="shape"
                        />
                      </filter>
                      <filter
                        id="filter3_d_338_25"
                        x="509.997"
                        y="177"
                        width="14.0034"
                        height="15"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="2" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.713726 0 0 0 0 0 0 0 0 0 0.505882 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_338_25"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_338_25"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="feature-img-container">
            <img
              className="feature-img prog-cap"
              src={progCap}
              alt="feature screencapture"
              onLoad={() => {
                ScrollTrigger.refresh();
              }}
            />
            <img className="feature-img report-cap" src={reportCap} alt="feature screencapture" />
          </div> */}
        </section>
        <section className="cta-section">
          <h3 className="cta-header">
            <span>Better </span>
            <span>decisions </span>
            <span>when </span>
            <span>they </span>
            <span>matter </span>
            <span>most </span>
          </h3>
          <Link className="cta" to="/dashboard">
            Get started
          </Link>
        </section>
      </div >
    </>
  );
}
